import { isRootSubdomain } from "common/utils/url";
import {
  useCurrentAdminQuery,
  useCurrentUserQuery,
} from "../generated/graphql";
import FullPageLoadingScreen from "./Common/FullPageLoadingScreen";
import { RootDomainRoutes } from "./RootDomainRoutes";
import { AccountSubdomainRoutes } from "./SubdomainRoutes";

export const MainRoutes = () => {
  const { loading, data } = useCurrentUserQuery();
  const { loading: loadingAdmin, data: adminData } = useCurrentAdminQuery();

  if (loading || loadingAdmin) return <FullPageLoadingScreen />;

  const props = {
    user: data?.currentUser,
    admin: adminData?.currentAdmin,
  };

  const isOnRootSubdomain = isRootSubdomain(window.location.href);

  return isOnRootSubdomain ?
      <RootDomainRoutes {...props} />
    : <AccountSubdomainRoutes {...props} />;
};
